// extracted by mini-css-extract-plugin
export default {"hero":"FaqHero_hero__VOfon","heroImage":"FaqHero_heroImage__u9PPi","heroContent":"FaqHero_heroContent__opXu-","title":"FaqHero_title__bz2r4","lead":"FaqHero_lead__JVy2r"};